// extracted by mini-css-extract-plugin
export default {"row":"Table_row__p-opd"};